export default __webpack_public_path__ + "static/media/pink-marker.4fa4e819.svg";